module.exports = function (cname, cvalue, exdays) {
    //This is a bit hacky, but probably sufficient for now
    const toBase64 = btoa || ((str) => str);
    if (exdays) {
        let d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = `expires=${d.toUTCString()}`;
        document.cookie = `${cname}=${toBase64(cvalue)};${expires}`;
    }
    else {
        document.cookie = `${cname}=${toBase64(cvalue)};`;
    }
}
